/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Back_PortalsInputs */

const cs_pm_back_portals = /** @type {(inputs: Pm_Back_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na portály`)
};

const en_pm_back_portals = /** @type {(inputs: Pm_Back_PortalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to portals`)
};

/**
* | output |
* | --- |
* | "Back to portals" |
*
* @param {Pm_Back_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_back_portals = /** @type {((inputs?: Pm_Back_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Back_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_back_portals(inputs)
	return cs_pm_back_portals(inputs)
});